<script>
  import { t } from "../../../core";

  export let name: string;
  export let deadline: string;
  export let showWarning: boolean = false;
</script>

<div class="status-table-row">
  <div
    class="status-table-cell status-table-cell--status"
    class:withBullet={showWarning == false}
    class:withWarning={showWarning}
  >
    {#if showWarning}
      <svg class="icon" width="19" height="17" aria-label="warning">
        <use xlink:href="#warning" />
      </svg>
    {/if}
    <span class:error-title={showWarning}>
      {#if showWarning}
        {t("StatusPanel.AwaitingYourSignature")}
      {/if}
      {name}
    </span>
  </div>
  <div class="status-table-cell">
    <span class="status-table-deadline">{deadline}</span>
  </div>
</div>

<style lang="scss">
  .status-table-row {
    display: grid;
    grid-template-columns: 1fr 0.5fr;
    grid-column-gap: 10px;
    margin-bottom: 18px;
    position: relative;
    line-height: 1.4;
  }

  .status-table-deadline {
    font-weight: bold;
  }

  .status-table-cell--status {
    display: flex;
    align-items: flex-start;
    padding-left: 13px;

    &.withBullet:before {
      content: "";
      position: absolute;
      left: 0;
      top: 5px;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 4px 0 4px 6px;
      border-color: transparent transparent transparent CurrentColor;
    }

    &.withWarning {
      &:not(:first-child) {
        margin-top: -8px;
      }
    }
  }

  .error-title {
    color: $warning-color;
  }

  .icon {
    margin-right: 7px;
    min-width: 16px;
  }
</style>
